export default "__VITE_ASSET__CNSC_2I5__"